FoxTheme.DOMready(function () {
  // Compare button functionality for product cards
  document.querySelectorAll('.js-compare-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const container = button.closest('sc-add-to-compare');

      if (container) {
        const checkbox = container.querySelector('input[type="checkbox"]');

        if (checkbox) {
          checkbox.click();
        }
      }
    });
  });
});
